var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"app-main",staticStyle:{"height":"100%"}},[_c('transition',{attrs:{"name":_vm.transitionName}},[_c('router-view',{key:_vm.key,class:_vm.transitionName!='none'?'child-view':''})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }